if (!customElements.get('product-thumbs')) {
  class ProductThumbs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swiper = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        direction: 'vertical',
        spaceBetween: 9,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });
    }
  }

  customElements.define('product-thumbs', ProductThumbs);
}
